var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounChooseThemes3076375(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62,3a1,1,0,0,0,0-.15,1,1,0,0,0,0-.14v0l0-.08-.08-.13-.1-.11-.11-.1-.13-.08-.08,0h0L61.2,2,61,2H3A1,1,0,0,0,2,3V61s0,0,0,0a1.55,1.55,0,0,0,.06.29v0l0,.08.08.13.1.11.11.1.13.08.08,0h0A1,1,0,0,0,3,62H61a1,1,0,0,0,1-1V3S62,3,62,3ZM55.55,50.24A12,12,0,1,1,43,31.39,1,1,0,0,1,44,33a10,10,0,0,0,10.47,15.7,1,1,0,0,1,1,1.57ZM4,58.59V4H58.59Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v3A1,1,0,0,1,20,13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.34,15.34a1,1,0,0,1-.71-.29l-2.12-2.12a1,1,0,0,1,1.41-1.41l2.12,2.12a1,1,0,0,1-.71,1.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,21H9a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22,28.78a1,1,0,0,1-.71-1.71L13.64,25a1,1,0,0,1,1.41,1.41l-2.12,2.12A1,1,0,0,1,12.22,28.78Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20,32a1,1,0,0,1-1-1V28a1,1,0,0,1,2,0v3A1,1,0,0,1,20,32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.78,28.78a1,1,0,0,1-.71-.29l-2.12-2.12A1,1,0,0,1,26.36,25l2.12,2.12a1,1,0,0,1-.71,1.71Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31,21H28a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.66,15.34a1,1,0,0,1-.71-1.71l2.12-2.12a1,1,0,0,1,1.41,1.41L26.36,15A1,1,0,0,1,25.66,15.34Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounChooseThemes3076375);
export default __webpack_public_path__ + "static/media/noun_choose_themes_3076375.076bf486.svg";
export { ForwardRef as ReactComponent };